import { plcDayjs } from '@utils/date';
import { isBrowser } from '@utils/server';
import { getAs, urlEnum } from '@utils/url';
import { Dayjs } from 'dayjs';

function getHourByHourRedirection(locality: string | string[] | undefined, hourByHourDay: Dayjs) {
  const href = `${urlEnum.hourByHour}${locality ? `/[locality]/[day]` : ''}`;

  return {
    as: getAs(
      href,
      locality
        ? {
            day: hourByHourDay ? hourByHourDay.format('YYYY-MM-DD') : plcDayjs().format('YYYY-MM-DD'),
            locality,
          }
        : {}
    ),
    href,
  };
}

function isSafari() {
  return (
    isBrowser() &&
    navigator.vendor &&
    navigator.vendor.indexOf('Apple') > -1 &&
    navigator.userAgent &&
    !/CriOS/.test(navigator.userAgent) &&
    !/FxiOS/.test(navigator.userAgent)
  );
}

function getDayAsLabel(day: Dayjs) {
  const now = plcDayjs();
  if (day.isSame(now, 'day')) {
    return 'common.today';
  }
  if (day.isSame(now.add(1, 'day'), 'day')) {
    return 'common.tomorrow';
  }
  if (day.isSame(now.add(2, 'day'), 'day')) {
    return 'common.day-after-tomorrow';
  }
  return null;
}

function buildDayLabel(dates: Dayjs[]) {
  return dates.map((d, i, array) => {
    if (i === array.length - 1) {
      return null;
    }
    if (i === 0 || !d.isSame(array[i - 1], 'day')) {
      return getDayAsLabel(d);
    }
    return null;
  });
}

export { getHourByHourRedirection, buildDayLabel, isSafari };
